import GameRankingCompare from "./GameRankingCompare";
export default GameRankingCompare;